/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolMusicNoteIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-music-note"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M9.93 21.9Q9.93 21.9 8.96 21.9Q8 21.9 6.61 20.51Q5.22 19.13 5.22 17.2Q5.22 15.28 6.61 13.89Q8 12.5 9.93 12.5Q10.5 12.5 10.99 12.57Q11.47 12.65 11.97 12.85L11.97 3.42Q11.97 2.88 12.36 2.49Q12.75 2.1 13.3 2.1L17.45 2.1Q18 2.1 18.39 2.49Q18.77 2.88 18.77 3.42L18.77 5.72Q18.77 6.28 18.39 6.66Q18 7.05 17.45 7.05L14.63 7.05L14.63 17.2Q14.63 19.13 13.24 20.51Q11.85 21.9 9.93 21.9Z" fill={color} />
    </svg>
  );
}
